import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { formateDate, transformStr3, getformListItemsdatas } from "@/utils/utils";
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import axios from 'axios';
import { mapState, mapGetters, mapMutations } from 'vuex';
let _ = require('lodash');
import { boundingExtent, getCenter } from 'ol/extent';
import { Polygon } from 'ol/geom';
import { transformExtent, fromLonLat, transform, toLonLat } from 'ol/proj';
export default {
  name: 'mapv2list',
  components: {},
  meta: {
    title: '地图设置列表'
  },
  data() {
    return {
      searchKey: '',
      // 搜索值
      mapdataform: {
        deptId: '',
        formId: '177623',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 地图设置表单项
      totalrow: 0,
      // 总条数
      dataList: [],
      // 列表数据
      dialogVisible: false,
      // 添加弹窗控制
      title: '',
      // 地图名称字段
      allareaData: [],
      // 行政区域总数据
      provinceList: [],
      // 省数据
      cityList: [],
      // 市数据
      areaList: [],
      // 区县数据
      streetList: [],
      // 乡镇街道数据
      defaultstreetList: [],
      // 乡镇街道数据
      provinceKey: '',
      // 省搜索字段
      cityKey: '',
      // 市搜索字段
      areaKey: '',
      // 区县搜索字段
      streetKey: '',
      // 区县搜索字段
      provinceIndex: '',
      // 省索引字段
      cityIndex: '',
      // 市索引字段
      areaIndex: '',
      // 区县索引字段
      streetIndex: '',
      // 区县索引字段
      specialId: ['1-1', '1-2', '1-9', '1-22', '1-32', '1-33', '1-34'],
      // 行政区直辖市及港澳台
      currentArea: {},
      // 当前选中行政值
      form: {
        title: '',
        currentAreaName: '',
        ishaschild: 2,
        mapTemplate: '标准模版',
        defaultArea: true,
        areajson: ''
      },
      currentAreaNameArr: [],
      currentAreaNameString: '',
      query: '',
      showindex: true,
      templateoptions: [{
        label: '标准模版',
        value: '标准模版'
      }, {
        label: '非遗模版',
        value: '非遗模版'
      }],
      chinaProperties: {
        adcode: '100000',
        name: '中国全域',
        center: [116.3683244, 39.915085],
        centroid: [104.113164, 37.570667],
        childrenNum: 34,
        level: 'country',
        parent: {
          adcode: null
        },
        bbox: [73.502355, 3.397162, 135.09567, 53.563269]
      },
      areaType: true,
      customJson: [],
      key1: 0,
      isAdd: true,
      editItem: {},
      streetTimer: null,
      timer: null,
      provinceCheck: [],
      cityCheck: [],
      areaCheck: [],
      streetCheck: [],
      disprovince: false,
      discity: false,
      disarea: false,
      disstreet: false,
      selectArea: [],
      selectAreaItem: ''
    };
  },
  created() {},
  mounted() {
    document.querySelector('html').style.height = '100%';
    document.querySelector('body').style.height = '100%';
    document.querySelector('#app').style.height = '100%';
    document.querySelector('#app').style.backgroundColor = '#F4F4F6';
    this.currentArea = this.chinaProperties;
    this.form.currentAreaName = this.areaType ? this.chinaProperties.name : this.form.title;
    this.SET_MAPGEOJSON(this.chinaProperties);
    this.getMapConfigList();
    this.getAreaList();
    this.query = this.$route.query;
  },
  computed: {
    ...mapGetters(['mapv2info'])
  },
  watch: {},
  methods: {
    ...mapMutations(['SET_MAPVIEWITEM', 'SET_MAPFORMITEM', 'SET_MAPGEOJSON', 'SET_MAPVIEW', 'SET_MAPSTYLE', 'SET_MAPSENIOR', 'SET_MAPSCREEN', 'SET_MAPDRAWLAYER']),
    /**
     * 获取地图设置数据
     */
    getMapConfigList() {
      let that = this;
      this.mapdataform.deptId = this.$route.query.fid;
      this.$api.singleadvanceSearch(this.mapdataform).then(res => {
        this.totalrow = res.totalRow;
        this.dataList = [];
        if (this.totalrow > 0) {
          that.dataList = res.dataList.map((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.createTime = formateDate(new Date(item.inserttime), 'yyyy-MM-dd hh:mm');
            item.itemformdata = itemformat;
            if (itemformat[50].length > 0) {
              let name;
              if (itemformat[50].includes(';')) {
                let nameArr = itemformat[50].split(';');
                let nameStr = [];
                nameArr.forEach(child => {
                  let prev = child.split('|')[0];
                  nameStr.push(prev.replace(/,/g, '-'));
                });
                item.itemformdata.areaName = nameStr.join(';');
              } else {
                name = itemformat[50].split('|')[0];
                item.itemformdata.areaName = name.replace(/,/g, '-');
              }
            }
            return item;
          });
        }
      });
    },
    /**
     * 搜索地图设置
     */
    searchHandle() {
      this.mapdataform.page = 1;
      let search = {
        model: 0,
        filters: [{
          'alias': 'title',
          'compt': 'editinput',
          'express': 'like',
          'val': this.searchKey
        }]
      };
      this.mapdataform.searchStr = encodeURI(JSON.stringify(search));
      this.getMapConfigList();
    },
    /**
     * 清除地图设置数据
     */
    clearSearch() {
      this.mapdataform.page = 1;
      this.mapdataform.searchStr = '';
      this.searchKey = '';
      this.getMapConfigList();
    },
    /**
     * 跳转配置页
    * @param {Object} item 数据
     */
    gotoConfig(item) {
      this.query.formUserId = item.id;
      let path = this.$router.resolve({
        path: '/mapconfigv2',
        query: this.query
      });
      window.open(location.protocol + '//' + location.host + location.pathname + path.href);
    },
    /**
     * 跳转地图展示页
    * @param {Object} item 数据
     */
    gotoMap(item) {
      this.query.formUserId = item.id;
      let path = this.$router.resolve({
        path: '/superMapv2',
        query: this.query
      });
      window.open(location.protocol + '//' + location.host + location.pathname + path.href);
    },
    /**
     * 删除操作
    * @param {Object} item 数据
     */
    deleteItem(item) {
      console.log(item);
      let that = this;
      ElMessageBox.confirm('确定要删除么？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        let deleteform = {
          formId: item.formId,
          formUserId: item.id
        };
        this.$api.deleteFormdata(deleteform).then(res => {
          if (res.status === 40101) {
            ElMessage({
              message: res.message,
              type: 'warning'
            });
          } else {
            ElMessage({
              message: '删除成功',
              type: 'success'
            });
            that.mapdataform.page = 1;
            that.getMapConfigList();
          }
        });
      }).catch(() => {});
    },
    /**
     * 获取中国省市地图区域JSON
     */
    getAreaList() {
      let that = this;
      axios.get(`${process.env.NODE_ENV === 'development' ? '/fileapi' : location.origin}/frontendTest1/openlayers/json/levelfeatures.json`).then(res => {
        console.log(res);
        that.allareaData = res.data;
        that.provinceList = res.data.children;
        that.showindex = false;
        console.log(that.provinceList);
      });
    },
    /**
     * 点击省操作
    * @param {Object} item 数据
    * @param {Number} index 索引
     */
    provinceHandle(item, index) {
      this.form.defaultArea = false;
      this.provinceIndex = index;
      let IsIndex = this.specialId.findIndex(child => {
        return child === item.treeID;
      });
      this.cityList = IsIndex > -1 ? [item] : item.children;
      this.currentAreaNameArr = [];
      // this.setCurrentArea(item, 0)
      this.areaList = [];
      this.streetList = [];
      this.cityIndex = '';
      this.areaIndex = '';
      this.streetIndex = '';
      this.cityCheck = [];
      this.areaCheck = [];
      this.streetCheck = [];
      this.provinceCheck = [item.treeID];
      this.selectAreaHandle(item);
    },
    /**
     * 点击市操作
    * @param {Object} item 数据
    * @param {Number} index 索引
     */
    cityHandle(item, index) {
      this.cityIndex = index;
      this.areaList = item.children;
      if (this.currentAreaNameArr.length > 2) this.currentAreaNameArr = this.currentAreaNameArr.slice(0, 2);
      // this.setCurrentArea(item, 1)
      this.streetList = [];
      this.areaIndex = '';
      this.streetIndex = '';
      this.areaCheck = [];
      this.streetCheck = [];
      this.cityCheck = [item.treeID];
      this.selectAreaHandle(item);
    },
    /**
     * 点击区县操作
    * @param {Object} item 数据
    * @param {Number} index 索引
     */
    areaHandle(item, index) {
      console.log(`item`, item);
      this.areaIndex = index;
      this.streetIndex = '';
      if (this.currentAreaNameArr.length > 3) this.currentAreaNameArr = this.currentAreaNameArr.slice(0, 3);
      // this.setCurrentArea(item, 2)
      let adcode = item.payload.objects.collection.geometries[0].properties.adcode;
      let that = this;
      axios.get(`${process.env.NODE_ENV === 'development' ? '/fileapi' : location.origin}/frontendTest1/openlayers/data/${adcode}_full.json`).then(res => {
        console.log(res);
        if (res.status === 200) {
          that.streetList = [...res.data.features];
          that.defaultstreetList = [...res.data.features];
          console.log(that.streetList);
        }
      }).catch(error => {
        if (error.response && error.response.status === 404) {
          that.streetList = [];
        }
      });
      this.streetCheck = [];
      this.areaCheck = [item.treeID];
      this.selectAreaHandle(item);
    },
    /**
     * 点击乡镇街道操作
    * @param {Object} item 数据
    * @param {Number} index 索引
     */
    streetHandle(item, index) {
      console.log(`item`, item);
      this.streetIndex = index;
      // this.setCurrentArea(item, 3)
      this.streetCheck = [item];
      this.selectAreaHandle(item);
    },
    /**
     * 设置当前选中区域
    * @param {Object} item 数据
    * @param {Number} index 索引
     */
    setCurrentArea(item, index) {
      this.currentArea = index !== 3 ? item.payload : item;
      let properties = index !== 3 ? item.payload.objects.collection.geometries[0].properties : item.properties;
      this.SET_MAPGEOJSON(properties);
      this.currentAreaNameArr[index] = properties;
      console.log(`this.currentAreaNameArr`, this.currentAreaNameArr);
      let name = [];
      this.currentAreaNameArr.forEach(elem => {
        name.push(elem.name);
      });
      this.form.currentAreaName = name.join('>');
    },
    /**
     * 清除当前选中区域
     */
    clearCurrentArea() {
      this.currentArea = {};
      this.form.currentAreaName = '';
    },
    /**
     * 省搜索操作
     */
    provinceSearch() {
      this.provinceList = [];
      this.cityList = [];
      this.areaList = [];
      this.streetList = [];
      if (this.provinceKey === '') {
        this.provinceList = this.allareaData.children;
        this.provinceIndex = '';
      } else {
        Object.keys(this.allareaData.children).forEach(item => {
          if (this.allareaData.children[item].name.includes(this.provinceKey)) {
            this.provinceList = [this.allareaData.children[item]];
            this.provinceIndex = 0;
          }
        });
      }
    },
    /**
     * 省搜索清除操作
     */
    provinceClose() {
      this.provinceKey = '';
      this.cityKey = '';
      this.areaKey = '';
      this.streetKey = '';
      this.provinceSearch();
      this.clearCurrentArea();
    },
    /**
     * 市搜索操作
     */
    citySearch() {
      this.cityList = [];
      this.areaList = [];
      this.streetList = [];
      this.cityList = this.provinceList[this.provinceIndex].children;
      this.cityIndex = '';
      if (this.cityKey !== '') {
        let flag = false;
        Object.keys(this.cityList).forEach(item => {
          if (this.cityList[item] && this.cityList[item].name.includes(this.cityKey)) {
            flag = true;
            this.cityList = [this.cityList[item]];
            this.cityIndex = 0;
          }
        });
        if (!flag) {
          this.cityList = [];
          this.cityIndex = '';
        }
      }
    },
    /**
     * 市搜索清除操作
     */
    cityClose() {
      this.cityKey = '';
      this.areaKey = '';
      this.streetKey = '';
      this.citySearch();
      this.clearCurrentArea();
    },
    /**
     * 区县搜索操作
     */
    areaSearch() {
      this.areaList = [];
      this.streetList = [];
      this.areaList = this.cityList[this.cityIndex].children;
      this.areaIndex = '';
      if (this.areaKey !== '') {
        let flag = false;
        Object.keys(this.areaList).forEach(item => {
          if (this.areaList[item] && this.areaList[item].name.includes(this.areaKey)) {
            flag = true;
            this.areaList = [this.areaList[item]];
            this.areaIndex = 0;
          }
        });
        if (!flag) {
          this.areaList = [];
          this.areaIndex = '';
        }
      }
    },
    /**
     * 区县搜索清除操作
     */
    areaClose() {
      this.areaKey = '';
      this.streetKey = '';
      this.areaSearch();
      this.clearCurrentArea();
    },
    /**
     * 乡镇街道搜索操作
     */
    streetSearch() {
      this.streetList = [];
      console.log(`defaultstreetList`, this.defaultstreetList);
      this.streetList = [...this.defaultstreetList];
      this.streetIndex = '';
      if (this.streetKey !== '') {
        let flag = false;
        console.log(`this.streetKey`, this.streetKey);
        Object.keys(this.streetList).forEach(item => {
          if (this.streetList[item] && this.streetList[item].properties.name.includes(this.streetKey)) {
            flag = true;
            this.streetList = [this.streetList[item]];
            this.streetIndex = 0;
          }
        });
        if (!flag) {
          this.streetList = [];
          this.streetIndex = '';
        }
      }
    },
    /**
     * 乡镇街道搜索清除操作
     */
    streetClose() {
      this.streetKey = '';
      this.streetSearch();
      this.clearCurrentArea();
    },
    /**
     * 分页操作
     */
    paginationHandle(val) {
      this.mapdataform.page = val;
      this.getMapConfigList();
    },
    /**
     * 弹窗确定操作
     */
    addDialog() {
      let that = this;
      this.$refs['form'].validate(valid => {
        if (valid) {
          // let views = this.currentArea
          // console.log(views)
          console.log(`this.form.defaultArea`, this.form.defaultArea);
          this.SET_MAPFORMITEM({
            title: this.form.title
          });
          let region = '';
          // 行政区域
          if (this.areaType) {
            if (this.selectArea.length > 0) this.form.defaultArea = false;
            console.log(`selectArea`, this.selectArea);
            let arearegion = [];
            let adcodes = [];
            let extent = [];
            let center = [];
            this.selectArea.forEach(elem => {
              arearegion.push(`${elem[0].join(',')}|${elem[1].join(',')}`);
              adcodes.push(elem[1][elem[1].length === 2 ? 1 : elem[1].length - 1]);
              center.push(elem[2]);
              extent.push(elem[3]);
            });
            console.log(`adcodes`, adcodes);
            if (this.selectArea.length > 1) {
              let dextent = [...extent[0]];
              extent.forEach(item => {
                dextent[0] = Math.min(dextent[0], item[0]);
                dextent[1] = Math.min(dextent[1], item[1]);
                dextent[2] = Math.max(dextent[2], item[2]);
                dextent[3] = Math.max(dextent[3], item[3]);
              });
              extent = dextent;
              center = getCenter(extent);
            } else {
              extent = extent[0];
              center = center[0];
            }
            if (!this.form.defaultArea && this.selectArea[0][0].length === 4) adcodes = [this.selectArea[0][1][this.selectArea[0][1].length - 2] + '_full'];
            this.SET_MAPVIEWITEM({
              adcode: !this.form.defaultArea ? adcodes.join(',') : this.chinaProperties.adcode,
              center: !this.form.defaultArea ? center : this.chinaProperties.center,
              extent: !this.form.defaultArea ? extent : this.chinaProperties.bbox,
              zoom: 11,
              minZoom: 10,
              maxZoom: 12
            });
            region = arearegion.join(';');
            if (this.form.defaultArea) region = this.form.currentAreaName;
            console.log(`region`, region);
          }
          // 自定义行政区域
          if (!this.areaType) {
            let properties = this.mapv2info.geojson.features[0].properties;
            this.SET_MAPVIEWITEM({
              adcode: 'region',
              center: properties.center,
              extent: properties.bbox
            });
            region = this.form.currentAreaName;
          }
          if (Object.keys(this.mapv2info.screen).length > 0) {
            if (this.mapv2info.screen.app) this.mapv2info.screen.app.view = {
              ...this.mapv2info.view
            };
            if (this.mapv2info.screen.pc) this.mapv2info.screen.pc.view = {
              ...this.mapv2info.view
            };
          }
          let jsonData = _.cloneDeep(this.mapv2info);
          delete jsonData.form;
          delete jsonData.routeSources;
          const dataList = [{
            'alias': 'title',
            'compt': 'editinput',
            'values': [{
              'val': this.form.title
            }]
          }, {
            'alias': '50',
            'compt': 'editinput',
            'values': [{
              'val': `${region}`
            }]
          }, {
            'alias': 'jsontxt',
            'compt': 'richtext',
            'values': [{
              'val': `<p element-id=\"init\" style="display: none;">${JSON.stringify(jsonData)}</p>`
            }]
          }, {
            'alias': 'ishaschild',
            'compt': 'radiobutton',
            'values': [{
              'val': this.form.ishaschild === 1 ? '是' : '否'
            }]
          }, {
            'alias': 'mapTemplate',
            'compt': 'selectbox',
            'values': [{
              'val': this.form.mapTemplate
            }]
          }];
          console.log(dataList);
          // return
          if (this.isAdd) {
            let formData = {
              deptId: this.$route.query.fid,
              formId: 177623,
              uid: this.$route.query.uid
            };
            this.$api.addFormdata(formData, encodeURI(JSON.stringify(dataList))).then(res => {
              ElNotification({
                message: '添加成功',
                type: 'success'
              });
              that.dialogVisible = false;
              that.mapdataform.page = 1;
              that.timer = setTimeout(() => {
                that.getMapConfigList();
                clearInterval(that.timer);
              }, 2500);
            });
          } else {
            dataList.push({
              'alias': 'onlyid',
              'compt': 'autonumber',
              'values': [{
                'val': this.editItem.itemformdata.onlyid
              }]
            });
            dataList.push({
              'alias': 'map_center',
              'compt': 'editinput',
              'values': [{
                'val': this.mapv2info.view.center
              }]
            });
            dataList.push({
              'alias': 'transform_extent',
              'compt': 'editinput',
              'values': [{
                'val': this.mapv2info.view.extent
              }]
            });
            // console.log(dataList)
            this.$api.editForm(this.query.fid, this.editItem.id, encodeURI(JSON.stringify(dataList)), this.editItem.formId).then(res => {
              ElMessage({
                message: '保存成功',
                type: 'success'
              });
              that.dialogVisible = false;
              that.mapdataform.page = 1;
              that.timer = setTimeout(() => {
                that.getMapConfigList();
                clearInterval(that.timer);
              }, 2500);
            });
          }
        }
      });
    },
    getAreaExtent(data) {
      let coordinateArr = data.geometry.coordinates[0];
      let defaultValue = coordinateArr[0];
      let [minLng, minLat, maxLng, maxLat] = [...defaultValue, ...defaultValue];
      coordinateArr.forEach(function (item, index) {
        let cLng = item[0];
        let cLat = item[1];
        if (cLng < minLng) minLng = cLng;
        if (cLat < minLat) minLat = cLat;
        if (cLng > maxLng) maxLng = cLng;
        if (cLat > maxLat) maxLat = cLat;
      });
      return [minLng, minLat, maxLng, maxLat];
    },
    defaultAreaHandle(val) {
      console.log(`val`, val);
      this.provinceList = this.allareaData.children;
      if (val) {
        this.currentArea = this.chinaProperties;
        this.form.currentAreaName = this.chinaProperties.name;
        this.SET_MAPGEOJSON(this.chinaProperties);
        let areaname = ['province', 'city', 'area', 'street'];
        this.cityList = [];
        this.areaList = [];
        this.streetList = [];
        areaname.forEach(elem => {
          this[`${elem}Index`] = '';
          this[`${elem}Key`] = '';
          this[`${elem}Key`] = '';
          this[`dis${elem}`] = false;
          this[`${elem}Check`] = [];
        });
      } else {
        this.currentArea = {};
        this.form.currentAreaName = '';
        this.SET_MAPGEOJSON({});
      }
    },
    maptitleChange(val) {
      if (!this.areaType) this.form.currentAreaName = val;
    },
    jsonblurHandle(val) {
      let jsondata = JSON.parse(this.form.areajson);
      let properties = jsondata.features[0].properties;
      properties.bbox = jsondata.features[0].bbox;
      properties.name = this.form.title;
      properties.center = this.getCoordinateCenter(properties.bbox);
      console.log(`blur`, jsondata);
      this.SET_MAPGEOJSON(jsondata);
    },
    getCoordinateCenter(data) {
      let center = [];
      center[0] = Number(((data[0] - data[2]) / 2 + data[0]).toFixed(8));
      center[1] = Number(((data[1] - data[3]) / 2 + data[1]).toFixed(8));
      return center;
    },
    areaRadioHandle(val) {
      if (!val) {
        this.form.currentAreaName = this.form.title;
      } else {
        let name = [];
        this.currentAreaNameArr.forEach(elem => {
          name.push(elem.name);
        });
        this.form.currentAreaName = name.join('>');
      }
    },
    addMap() {
      if (this.$refs['form']) this.$refs['form'].resetFields();
      this.defaultAreaHandle(true);
      this.SET_MAPVIEW({
        zoom: 11,
        minZoom: 10,
        maxZoom: 12
      });
      this.SET_MAPSTYLE({});
      this.SET_MAPSENIOR({});
      this.SET_MAPSCREEN({});
      this.SET_MAPDRAWLAYER({});
      // console.log(this.form)
      this.form = {
        title: '',
        ishaschild: 2,
        mapTemplate: '标准模版',
        defaultArea: true,
        areajson: ''
      };
      this.areaType = true;
      if (this.form.defaultArea) {
        this.provinceClose();
        this.currentArea = this.chinaProperties;
        this.form.currentAreaName = this.chinaProperties.name;
      }
      this.isAdd = true;
      this.dialogVisible = true;
    },
    editMap(val) {
      let that = this;
      // console.log(`val`, val)
      if (this.$refs['form']) this.$refs['form'].resetFields();
      this.defaultAreaHandle(true);
      this.editItem = _.cloneDeep(val);
      let editInfo = this.editItem.itemformdata;
      this.form.title = editInfo.title;
      this.form.currentAreaName = editInfo.areaName.replace(/-/g, '>');
      this.form.ishaschild = editInfo.ishaschild === '是' ? 1 : 2;
      this.form.mapTemplate = editInfo.mapTemplate;
      let jsontxt = JSON.parse(editInfo.jsontxt.replace(/(<\/?p.*?>)/gi, ''));
      // console.log(`jsontxt`, jsontxt)
      this.SET_MAPVIEW(jsontxt.view);
      this.SET_MAPSTYLE(jsontxt.style);
      this.SET_MAPSENIOR(jsontxt.senior);
      this.SET_MAPSCREEN(jsontxt.screen);
      this.SET_MAPDRAWLAYER(jsontxt.drawlayer);
      this.areaType = jsontxt.geojson && jsontxt.geojson.features ? false : true;
      this.form.areajson = !this.areaType ? JSON.stringify(jsontxt.geojson) : '';
      this.form.defaultArea = jsontxt.geojson.adcode && Number(jsontxt.geojson.adcode) === 100000 ? true : false;
      if (this.form.defaultArea) {
        this.provinceClose();
        this.form.currentAreaName = this.chinaProperties.name;
      }
      if (!this.form.defaultArea && this.areaType) {
        // 取出行政区域的 级别个数、行政区域的各级别值
        let geojson = jsontxt.geojson;
        if (Object.prototype.toString.call(jsontxt.geojson) === '[object Object]') geojson = [jsontxt.geojson];
        // console.log(`geojson`, geojson)
        let areaName = geojson[0].name;
        let levelNameArr;
        let levelLen = 1;
        if (geojson.length > 1) {
          areaName = [];
          geojson.forEach(data => {
            areaName.push(data.name);
          });
        }
        // console.log(`areaName`, areaName);
        levelLen = geojson[0].acroutes ? geojson[0].acroutes.length : 4;
        levelNameArr = this.form.currentAreaName.includes(';') ? [...this.form.currentAreaName.split(';')[0].split('>')] : [...this.form.currentAreaName.split('>')];
        levelNameArr.pop();
        levelNameArr.push(areaName);
        // console.log(`levelNameArr`, levelNameArr);
        // console.log(`levelLen`, levelLen);
        // console.log(`this.form.currentAreaName`, this.form.currentAreaName);
        // return
        if (levelLen > 0) {
          if (Object.prototype.toString.call(levelNameArr[0]) === '[object Array]') {
            this.provinceList = this.allareaData.children;
            this.provinceCheck = [];
            levelNameArr[0].forEach(name => {
              Object.keys(this.provinceList).forEach(key => {
                if (name === this.provinceList[key].name) this.provinceCheck.push(this.provinceList[key].treeID);
              });
            });
            this.multipleArea(this.provinceCheck, 'province');
          } else {
            this.provinceKey = levelNameArr[0];
            this.provinceSearch();
            let item = this.provinceList.find(elem => {
              return elem.name === levelNameArr[0];
            });
            this.provinceHandle(item, 0);
          }
        }
        if (levelLen > 1) {
          if (Object.prototype.toString.call(levelNameArr[1]) === '[object Array]') {
            let item = this.provinceList.find(elem => {
              return elem.name === levelNameArr[0];
            });
            let IsIndex = this.specialId.findIndex(child => {
              return child === item.treeID;
            });
            this.cityList = IsIndex > -1 ? [item] : item.children;
            levelNameArr[1].forEach(name => {
              Object.keys(this.cityList).forEach(key => {
                if (name === this.cityList[key].name) this.cityCheck.push(this.cityList[key].treeID);
              });
            });
            this.multipleArea(this.cityCheck, 'city');
          } else {
            this.cityKey = levelNameArr[1];
            this.citySearch();
            let item = this.cityList.find(elem => {
              return elem.name === levelNameArr[1];
            });
            this.cityHandle(item, 0);
          }
        }
        if (levelLen > 2) {
          if (Object.prototype.toString.call(levelNameArr[2]) === '[object Array]') {
            let item = this.cityList.find(elem => {
              return elem.name === levelNameArr[1];
            });
            this.areaList = item.children;
            levelNameArr[2].forEach(name => {
              Object.keys(this.areaList).forEach(key => {
                if (name === this.areaList[key].name) this.areaCheck.push(this.areaList[key].treeID);
              });
            });
            this.multipleArea(this.areaCheck, 'area');
          } else {
            this.areaKey = levelNameArr[2];
            this.areaSearch();
            let item = this.areaList.find(elem => {
              return elem.name === levelNameArr[2];
            });
            this.areaHandle(item, 0);
          }
        }
        if (levelLen > 3) {
          if (Object.prototype.toString.call(levelNameArr[3]) === '[object Array]') {
            this.streetTimer = setInterval(() => {
              if (that.streetList.length > 0) {
                levelNameArr[3].forEach(name => {
                  that.streetList.forEach(street => {
                    if (name === street.properties.name) that.streetCheck.push(street);
                  });
                });
                that.multipleArea(that.streetCheck, 'street');
                clearInterval(that.streetTimer);
              }
            }, 100);
          } else {
            this.streetKey = levelNameArr[3];
            this.areaHandle(this.areaList[0], 0);
            this.streetTimer = setInterval(() => {
              if (this.streetList.length > 0) {
                this.streetList = this.defaultstreetList.filter(item => {
                  return item.properties.name === this.streetKey;
                });
                this.streetHandle(this.streetList[0], 0);
                clearInterval(this.streetTimer);
              }
            }, 100);
          }
        }
      }
      this.isAdd = false;
      this.dialogVisible = true;
    },
    multipleArea(val, type) {
      if (val.length > 0) this.form.defaultArea = false;
      let arr = ['province', 'city', 'area', 'street'];
      this.selectArea = [];
      let getJson = [];
      if (val.length > 0) {
        val.forEach(elem => {
          if (type !== 'street') {
            this.selectArea.push(this.getAreaItem(this.allareaData, elem, []));
          } else {
            let area = _.cloneDeep(this.selectAreaItem[0]);
            this.selectArea.push(this.formatAreaData(area, elem));
          }
        });
      }
      this.form.currentAreaName = this.selectArea.map(item => {
        return item[0].join('>');
      }).join(';');
      // 选项大于1 行政区域多选操作
      if (val.length > 1) {
        arr.forEach(elem => {
          if (elem !== type) this[`dis${elem}`] = true;
        });
        this.selectArea.forEach(elem => {
          getJson.push(type !== 'street' ? elem[4].payload.objects.collection.geometries[0].properties : elem[4]);
        });
      } else {
        arr.forEach(elem => {
          this[`dis${elem}`] = false;
        });
        getJson = type !== 'street' ? this.selectArea[0][4].payload.objects.collection.geometries[0].properties : this.selectArea[0][4];
      }
      // console.log(`getJson`, getJson)
      this.SET_MAPGEOJSON(getJson);
    },
    selectAreaHandle(item) {
      let treeId = item.treeID;
      let info = this.getAreaItem(this.allareaData, item.treeID, []);

      // 记录点击省市区县操作
      if (info !== null) {
        this.selectArea = [info];
        this.SET_MAPGEOJSON(item.payload.objects.collection.geometries[0].properties);
        if (info[0].length === 3) this.selectAreaItem = [...this.selectArea];
      }
      // 记录点击乡镇街道操作
      if (info === null) {
        let area = _.cloneDeep(this.selectAreaItem);
        this.selectArea = [this.formatAreaData(area[0], item)];
        this.SET_MAPGEOJSON(item.properties);
      }
      this.form.currentAreaName = this.selectArea.map(item => {
        return item[0].join('>');
      })[0];
    },
    formatAreaData(area, elem) {
      const areaPolygon = new Polygon(elem.geometry.coordinates);
      const extent = areaPolygon.getExtent();
      const center = getCenter(extent);
      if (area[0].length === 3) {
        area[0].push(elem.properties.name);
        area[1].push(Number(elem.properties.code));
      } else if (area[0].length === 4) {
        area[0].splice(3, 1, elem.properties.name);
        area[1].splice(3, 1, Number(elem.properties.code));
      }
      area[2] = center;
      area[3] = extent;
      area[4] = elem.properties;
      return area;
    },
    getAreaItem(node, id, path) {
      if (node.treeID === id) {
        let nodeInfo = [path];
        let payload = _.cloneDeep(node.payload);
        let properties = payload.objects.collection.geometries[0].properties;
        let code = [...properties.acroutes, properties.adcode];
        nodeInfo.push(code);
        nodeInfo.push(properties.center);
        nodeInfo.push(payload.bbox);
        nodeInfo.push(node);
        return nodeInfo;
      }
      if (Object.keys(node.children).length > 0) {
        // for循环则是跳出全部循环 forEach中的return 只会跳出本次循环函数
        for (let child in node.children) {
          let newPath = path.concat(node.children[child].name);
          let found = this.getAreaItem(node.children[child], id, newPath);
          if (found) return found;
        }
      }
      return null;
    }
  }
};